module.exports = __webpack_public_path__ + "static/media/mh.6d60cee3.svg";